import React, { Component } from 'react';
// import Config from './Config';
// import List from './List';
//import { Scrollbars } from 'react-custom-scrollbars';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class Preferences extends Component {  constructor(props) {
  super(props);
    this.state = {integrations:{}};
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData = (limit) => {
    var data = {customer_id: this.props.root.state.customer_id};
    console.log(data);
    console.log('--------------');
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'integrations' + qs, (res, i) => {
      console.log(res);
      this.setState({ integrations : res });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    //var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {customer_id:  this.props.root.state.customer_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      this.props.root.setState({detail: res.product});
      console.log(res);
    });
  }
  render() {
    console.log(this.state);
    console.log(this.state.integrations.active);
      var integrations;
      if(this.state.integrations.integrations){
          integrations = this.state.integrations.integrations.active.map((integ) => {
              return (
                <tr>
                    <td>
                        {integ.platform}
                    </td>
                    <td>
                        {integ.forename} {integ.surname}
                    </td>
                    <td>
                        {integ.email}
                    </td>
                    <td>
                       <button>Set Password</button>
                    </td>
                    <td>
                       <button>Delete integ</button>
                    </td>
                </tr>
             )
          });
      }
      var available;
      if(this.state.integrations.integrations){
          available = this.state.integrations.integrations.available.map((integ) => {
              return (
                <div className="Available">
                    <div>
                        {integ.platform}
                    </div>
                    <div>
                        {integ.title}
                    </div>
                </div>
             )
          });
      }
      return (
        <div className="Preferences">
          Preferences
          <div>
            {available}
          </div>
          <div style={{clear:'both',marginTop: 10, marginBottom: 10, borderBottom:'solid 1px #ccc'}} />
          <table>
            {integrations}
          </table>
          <button>Add Preferences</button>
        </div>
      );
  }
}

export default Preferences;



// WEBPACK FOOTER //
// ./src/Preferences.js